import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Analyze Feedback | Canny';
const Description =
  'Analyze your product feedback to identify which features will be most impactful to work on.';
const Image = 'https://canny.io/images/canny-social.png';
const AnalyzeFeedbackUrl = 'https://canny.io/features/analyze-feedback';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${AnalyzeFeedbackUrl}#webpage`,
    url: AnalyzeFeedbackUrl,
    name: 'Analyze Your Product Feedback - Canny',
    description:
      'Identify which features will be most impactful to work on by adding relevant data, segmenting customers, and digging deeper into feedback.',
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${AnalyzeFeedbackUrl}#capabilities`,
    'Feedback Analysis Capabilities',
    [
      {
        name: 'Add Relevant Business Data',
        description:
          'Send company data such as monthly spend and custom fields to better understand where feedback is coming from.',
      },
      {
        name: 'Segment & Filter Feedback',
        description:
          'Build custom segments to filter feedback from your most valuable customers and identify high-impact requests.',
      },
      {
        name: 'Dig Deeper with Conversations',
        description:
          'Start conversations directly with users to clarify feature requests, gather context, and investigate further using internal notes.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Features', item: 'https://canny.io/features' },
    { name: 'Analyze Feedback', item: AnalyzeFeedbackUrl },
  ]),
]);

export default class LandingAnalyzeFeedbackHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: AnalyzeFeedbackUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
